/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Use_Crystal_TreeInputs */

const en_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy Seasonal Select Crystal Trees`)
};

const ar_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بـ أشجار كريستالية موسمية مختارة`)
};

const de_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie Saisonal ausgewählte Kristallbäume`)
};

const es_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta los Árboles de cristal de temporada seleccionados`)
};

const fr_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez d'Arbres premium de saison`)
};

const it_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi la Selezione stagionale degli alberi di cristalli`)
};

const ja_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン限定クリスタルツリーを楽しむ`)
};

const ko_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시즌별 엄선된 크리스탈 나무를 만나보세요`)
};

const pt_br_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite as Árvores sazonais de Cristais do Tempo`)
};

const ru_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наслаждайтесь сезонными кристальными деревьями на выбор`)
};

const th_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินกับต้นไม้คริสตัลที่คัดสรรตามฤดูกาล`)
};

const tr_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevsimsel Seçkin Kristal Ağaçlarnın keyfini çıkar`)
};

const zh_cn_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限使用当季精选宝石树`)
};

const zh_tw_free_use_crystal_tree = /** @type {(inputs: Free_Use_Crystal_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無限使用當季精選寶石樹`)
};

/**
* | output |
* | --- |
* | "Enjoy Seasonal Select Crystal Trees" |
*
* @param {Free_Use_Crystal_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const free_use_crystal_tree = /** @type {((inputs?: Free_Use_Crystal_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Use_Crystal_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_use_crystal_tree(inputs)
	if (locale === "ar") return ar_free_use_crystal_tree(inputs)
	if (locale === "de") return de_free_use_crystal_tree(inputs)
	if (locale === "es") return es_free_use_crystal_tree(inputs)
	if (locale === "fr") return fr_free_use_crystal_tree(inputs)
	if (locale === "it") return it_free_use_crystal_tree(inputs)
	if (locale === "ja") return ja_free_use_crystal_tree(inputs)
	if (locale === "ko") return ko_free_use_crystal_tree(inputs)
	if (locale === "pt_br") return pt_br_free_use_crystal_tree(inputs)
	if (locale === "ru") return ru_free_use_crystal_tree(inputs)
	if (locale === "th") return th_free_use_crystal_tree(inputs)
	if (locale === "tr") return tr_free_use_crystal_tree(inputs)
	if (locale === "zh_cn") return zh_cn_free_use_crystal_tree(inputs)
	return zh_tw_free_use_crystal_tree(inputs)
});